﻿<template>
    <header class="header print:hidden">
        <header_menu></header_menu>
        <hero v-if="isValidView()" :title="getConfirmationText()" :subtitle="getSubtitle()" :hero_image="getHeroImage()"></hero>
        <hero v-else-if="!isValidView()" title="404 (page not found)" subtitle="Whoops! You've hit a 404 (page not found). Sorry, you'll have to turn around." :hero_image="getHeroImage()"></hero>
        <div v-if="!isValidView()" class="flex flex-col items-center"><button type="button" class="m-10 px-10 py-2 button button-pink-book" @click="home_Click()">Return to Home Page</button></div>
    </header>

    <main class="main cart-page" v-if="isValidView()" id="main">

        <div v-if="(!isAgent_Login() && (GetBrand() == 'HEX' || GetBrand() == 'HAG')) && is_fully_paid()" class="td-contact conf-email-note">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
            <span v-if="GetBrand() == 'HEX'">If you don't receive a confirmation email please contact us at <a href="mailto:info@highlandexplorertours.com">info@highlandexplorertours.com</a></span>
            <span v-if="GetBrand() == 'HAG'">If you don't receive a confirmation email please contact us at <a href="mailto:info@haggisadventures.com">info@haggisadventures.com</a></span>
        </div>

        <div class="cart-head">
            <div>
                <h1 v-if="is_fully_paid()">Booked itinerary</h1>
                <h1 v-else-if="is_part_paid()">Partially paid itinerary</h1>
                <h1 v-else>Attempted booking itinerary</h1>
                <p class="cart-subtitle">Booking reference <strong>#{{ group_booking_id }}</strong></p>
            </div>
            <div class="conf-tools print:hidden">
                <button type="button" class="cart-continue" @click="savePage2PDF()">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>
                    Save PDF
                </button>
                <button type="button" class="cart-continue" onclick="window.print()">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" /></svg>
                    Print
                </button>
            </div>
        </div>

        <!-- One summary (was rendered twice, for mobile and desktop); on small screens it sits under the booked trips. -->
        <div class="cart-layout conf-layout">
            <div class="cart-main conf-main">
                <basket></basket>
                <documentation :class="{'hidden': isAgent_Login() == false}"></documentation>
            </div>

            <trip_summary class="conf-side"></trip_summary>

            <div v-if="!isAgent_Login() && show_FloDesk()" class="conf-extra print:hidden">
                <iframe :src="getFloDeskURL()" class="conf-flodesk" title="Newsletter sign-up"></iframe>
            </div>
        </div>

    </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./5_confirmation.ts"></script>